import * as sharedFuelTypesSpecifications from '../../common/vehicleSpecifications/fuelTypes.js'

// Define only the vehicle specifications that are different from the common ones
export const FUEL_TYPES_IDS = {
  ...sharedFuelTypesSpecifications.FUEL_TYPES_IDS,
  DIESEL: '1',
  HYBRID: '4',
  HYBRID_PLUG_IN: '5',
  GLP: '6',
  CNG: '7',
  OTHER: '8'
}

export const FUEL_TYPES = {
  ...sharedFuelTypesSpecifications.FUEL_TYPES,
  [FUEL_TYPES_IDS.DIESEL]: {
    id: FUEL_TYPES_IDS.DIESEL,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_DIESEL'
  },
  [FUEL_TYPES_IDS.HYBRID]: {
    id: FUEL_TYPES_IDS.HYBRID,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_HYBRID'
  },
  [FUEL_TYPES_IDS.HYBRID_PLUG_IN]: {
    id: FUEL_TYPES_IDS.HYBRID_PLUG_IN,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_HYBRID_PLUG_IN'
  },
  [FUEL_TYPES_IDS.GLP]: {
    id: FUEL_TYPES_IDS.GLP,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_GLP'
  },
  [FUEL_TYPES_IDS.CNG]: {
    id: FUEL_TYPES_IDS.CNG,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_CNG'
  },
  [FUEL_TYPES_IDS.OTHER]: {
    id: FUEL_TYPES_IDS.OTHER,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_OTHER'
  }
}
